/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-goods-card.vue?vue&type=template&id=06285a52&scoped=true"
import script from "./pc-goods-card.vue?vue&type=script&lang=js"
export * from "./pc-goods-card.vue?vue&type=script&lang=js"
import style0 from "./pc-goods-card.vue?vue&type=style&index=0&id=06285a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06285a52",
  null
  
)

export default component.exports